const getOptionId = (value: any) => value?.id ?? value;

const getVisitActivities = (visit: any) => {
    return Array.isArray(visit?.actividades) ? visit.actividades : [];
};

export const getVisitTypeDescriptions = (visit: any) => {
    const descriptions = getVisitActivities(visit)
        .map((activity: any) => activity?.tipoVisita?.descripcion)
        .filter(Boolean);

    return Array.from(new Set(descriptions)) as string[];
};

export const hasMultipleVisitTypes = (visit: any) => {
    return getVisitTypeDescriptions(visit).length > 1;
};

export const getVisitActivity = (visit: any, selectedVisitType?: any) => {
    const activities = getVisitActivities(visit);
    const selectedVisitTypeId = getOptionId(selectedVisitType);

    if (selectedVisitTypeId) {
        const selectedActivity = activities.find(
            (activity: any) => Number(activity?.tipoVisita?.id) === Number(selectedVisitTypeId)
        );

        if (selectedActivity) return selectedActivity;
    }

    return activities[0];
};

export const getVisitTypeId = (visit: any, selectedVisitType?: any) => {
    return getVisitActivity(visit, selectedVisitType)?.tipoVisita?.id ?? visit?.tipo;
};

export const getVisitTypeDescription = (visit: any, selectedVisitType?: any) => {
    if (hasMultipleVisitTypes(visit)) return 'MÚLTIPLE';

    const selectedActivityDescription = getVisitActivity(visit, selectedVisitType)?.tipoVisita
        ?.descripcion;

    if (selectedActivityDescription) return selectedActivityDescription;

    if (visit?.tipoVisita?.descripcion) return visit.tipoVisita.descripcion;
    if (visit?.nombreTipoVisita) return visit.nombreTipoVisita;
    if (visit?.tipo) return String(visit.tipo);

    return '-';
};
